import React from "react";
import { IResourceComponentsProps } from "@refinedev/core";
import Cw8Edit from "components/cw8/Cw8Edit";

export const FragmentTypesEdit: React.FC<IResourceComponentsProps> = () => {

    const resourceName :string = "fragmentType";
    return (
        <Cw8Edit
            resourceName = {resourceName}
        ></Cw8Edit>
    );
};
